export default __webpack_public_path__ + "static/media/use_action_xw.555e87b0.png";